<script>
    import { onMount } from "svelte";
    import { Router, Link, Route } from "svelte-routing";
    import { produce } from "../stores";
</script>

<Router>
    <ul>
        {#each $produce as prod}
            <li><Link to={prod.slug}>{prod.name}</Link></li>
        {/each}
    </ul>
    <div />
</Router>
